import Reflux from 'reflux-react-16'

export default Reflux.createActions([
    'getAccounts',
    'login',
    'switchAccount',
    'logout',
    'loggedIn',

    'getAccount',
    'updateUserSettings',

    'getReseller',

    'generateMFAKey',
    'mailMFACode',
    'reset2FA',

    'checkNotifications',
    'updateReadNotifications',

    'getBranding'
])
